import { Outlet } from '@tanstack/react-router'
import { SideNav } from './SideNav'
import { usePushSync } from '@/features/push/usePushDevice'

/* Spec PWA-001 — moldura de toda a area autenticada. No celular nao acrescenta nada (a barra inferior
   fica no AppShell das abas); em telas largas (>= lg) poe o menu lateral fixo e desloca o conteudo.
   PWA-014 D-04: com sessao, mantem a inscricao deste aparelho em dia (e no idioma atual), sem mostrar nada. */
export function AuthLayout() {
    usePushSync()
    return (
        <>
            <SideNav className="hidden lg:flex" />
            <div className="lg:pl-64">
                <Outlet />
            </div>
        </>
    )
}
